import React, { useState, useEffect } from 'react';
import { MAX_CONTENT_WIDTH } from '../constants/layout';

export default function AboutPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div style={{
      backgroundColor: 'var(--color-background)',
      minHeight: 'calc(100vh - 80px)',
      display: 'flex',
      alignItems: 'center',
    }}>
      <div style={{
        maxWidth: MAX_CONTENT_WIDTH,
        margin: '0 auto',
        padding: '20px',
        width: '100%',
      }}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '40px',
          alignItems: 'center',
        }}>
          {/* Text */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <h1 style={{
              color: 'var(--color-text-primary)',
              fontSize: '2.5rem',
              fontWeight: 700,
              fontFamily: 'Helvetica, Arial, sans-serif',
              letterSpacing: '-0.04em',
              marginBottom: '8px',
            }}>
              Davin
            </h1>

            <p style={{
              color: 'var(--color-text-secondary)',
              fontSize: '0.875rem',
              fontFamily: 'Helvetica, Arial, sans-serif',
              letterSpacing: '-0.01em',
              marginBottom: '40px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}>
              Southern California
              <span style={{ color: 'var(--color-text-secondary)', opacity: 0.4 }}>·</span>
              <a
                href="https://instagram.com/davinese"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'var(--color-text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-text-primary)'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-text-secondary)'}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                </svg>
                @davinese
              </a>
            </p>

            <p style={{
              color: 'var(--color-text-primary)',
              fontSize: '1rem',
              fontFamily: 'Helvetica, Arial, sans-serif',
              lineHeight: 1.7,
              margin: 0,
              maxWidth: '540px',
            }}>
              I'm Davin. I got my first MacBook in 2017, in high school, and started teaching myself to edit videos in Final Cut Pro and build apps with UIKit in Xcode. In 2021, I did my first set as a PA after meeting a director at the restaurant I was working at, who invited me on. Since then, I've been on student and indie productions in camera and G&E, as well as producing.
            </p>
          </div>

          {/* Photo */}
          <div style={{
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            aspectRatio: '4 / 3',
          }}>
            <img
              src="/images/davin.jpg"
              alt="Davin on set"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center 30%',
                display: 'block',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
